import React from 'react';
import { useTranslation } from 'react-i18next';
import FullInfoField from 'components/FullInfoField/FullInfoField';

interface IProps {
	splitPayments3S: boolean;
}

export const SplitPayments3SCheckbox: React.FC<IProps> = ({ splitPayments3S }) => {
	const { t } = useTranslation('form');
	const inputValue = splitPayments3S ? t('yes') : t('no');

	return (
		<FullInfoField
			label="splitPayments3SLabel"
			value={inputValue}
			prefixIcon="asCheckbox"
			prefixIconName={splitPayments3S ? 'checkMark' : 'crossMark'}
			prefixIconIsChecked={splitPayments3S}
		/>
	);
};
